<template>
<span>
	<div style="padding: 20px;"></div>
  <div class="footer">  
            <b-container fluid class="footer-bottom text-center" style="padding-left:10%;">
            <!-- p>For daily updates, Find us on:</p>
            <b-row class="social">
                <b-col cols="2" xs="2" sm="1" md="1" offset="2" offset-sm="4" offset-md="4" class="social-link"><b-link href="https://www.instagram.com/alluraashop" target="_blank"><img src="../assets/Instagram.png"></b-link></b-col>
                <b-col cols="2" xs="2" sm="1" md="1" class="social-link"><b-link href="https://twitter.com/AlluraaTech" target="_blank"><b-img src="../assets/twitter.png"></b-img></b-link></b-col>
                <b-col cols="2" xs="2" sm="1" md="1" class="social-link"><b-link href="https://www.linkedin.com/company/alluraa/" target="_blank"><b-img src="../assets/Linkedin.png"></b-img></b-link></b-col>
                <b-col cols="2" xs="2" sm="1" md="1" class="social-link"><b-link href="https://www.facebook.com/AlluraaTech" target="_blank"><b-img src="../assets/facebook.png"></b-img></b-link></b-col>
            </b-row>-->
           
                <p class="p-0 font-md m-0" style="">© 2021 APPACK TECHNOLOGIES LLP</p>
               
         
        </b-container>
  </div>
  </span>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  computed: {
    passwordState() {
      return this.new_password.length > 3 ? true : false
    }
  },
  data() {
    return{
    }
  },
  methods:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	
	.footer {
	  position: fixed;
	  left: 0;
	  bottom: 0;
	  width: 100%;
	 
	}
    .footer .footer-top{
     max-width: 90% !important;     
    margin-left: 10% !important;
    }
    .footerLinkul{
     padding: 0px !important;
    }
.footerLinkul li {
    display: block;
    margin: 0 0px !important;
    line-height: 24px;
    font-size: 0.9rem !important;
    text-align: left;
}

.footer .footer-bottom{
/* padding-top: 0px;
padding-bottom: 7px;*/
    padding: 13px 0px 10px 0px;
}


</style>
